<template>
  <div class="page-content">
    <!--  ABRE MODAL LEGAJO -->
    <div id="info_legajo" style="overflow-y:scroll;">
      <div id="header_legajo">
        <button id="cerrar_legajo" style="position: absolute;right: 20px;margin-top: 3px;background-color:red;font-weight: bold;color:#fff;">CERRAR INFORME</button>
      </div>
      <table width="100%">
        <tr>
          <td width="210px"><center style="padding: 10px;"><div id="legajo_foto"></div></center></td>
          <td valign="top" style="padding: 10px;">
            <table width="100%">
              <tr><td width="200px">Nombre y Apellido</td><td></td></tr>
              <tr><td>DNI</td><td></td></tr>
              <tr><td>Fecha de Nacimiento</td><td></td></tr>
              <tr><td>Fecha de Ingreso</td><td></td></tr>
              <tr><td>Categoría</td><td></td></tr>
              <tr><td>Domicilio</td><td></td></tr>
              <tr><td>Provincia</td><td></td></tr>
              <tr><td>Ciudad</td><td></td></tr>
              <tr><td>Nacionalidad</td><td></td></tr>
              <tr><td>Tel. Celular</td><td></td></tr>
              <tr><td>Email</td><td></td></tr>
            </table>
          </td>
          <td width="700px" valign="top" style="padding: 10px;">
            <table width="100%">
              <tr><td align="center">DIAS</td><td align="center">VACUNAS</td><td align="center">CMA</td></tr>
              <tr><td align="center"><div class="circulo"></div></td><td align="center"><div class="circulo"></div></td><td align="center"><div class="circulo"></div></td></tr>
            </table>
            <br><br>
            <table width="100%">
              <tr><td width="200px">OPERACIÓN</td><td></td></tr>
              <tr><td>RESPONSABLE</td><td></td></tr>
            </table>
          </td>
        </tr>
      </table>
    </div>
    <!--  CIERRA MODAL LEGAJO -->
    <nav class="page-breadcrumb" id="breadcrumb">
      <ol class="breadcrumb">
        <li class="breadcrumb-item">{{breadcrumbA}}</li>
        <li class="breadcrumb-item active" aria-current="page">{{breadcrumbB}}</li>
      </ol>
    </nav>
    <div class="row">
      <div class="col-md-12 grid-margin stretch-card">
        <div class="card">
          <div class="card-body">
            <h6 class="card-title"><i class="link-icon" data-feather="box"></i> {{breadcrumbB}}</h6>
            <p class="card-description">{{descripcion}}</p>
            <div style="position:absolute;right: 80px;margin-top: -67px;">
              <table>
                <tr>
                  <td><span class="badge badge-success" style="background-color:#548aa9">Masculinos</span>:</td>
                  <td><b id="masculinos" style="font-size:17px;margin-left:10px;">0</b></td>
                  <td><span class="badge badge-success">Food Service America</span>:</td>
                  <td><b id="america_count" style="font-size:17px;margin-left:10px;">0</b></td>
                  <td><span class="badge badge-success">EN CONVENIO</span>:</td>
                  <td><b id="ameconv_count" style="font-size:17px;margin-left:10px;">0</b></td>
                  <td><span class="badge badge-success">FUERA DE CONVENIO</span>:</td>
                  <td><b id="ameconvno_count" style="font-size:17px;margin-left:10px;">0</b></td>
                </tr>
                <tr>
                  <td><span class="badge badge-success" style="background-color:#b56aa2">Femeninos</span>:</td>
                  <td><b id="femeninos" style="font-size:17px;margin-left:10px;">0</b></td>
                  <td><span class="badge badge-info">Food Service Catering</span>:</td>
                  <td><b id="catering_count" style="font-size:17px;margin-left:10px;">0</b></td>
                  <td><span class="badge badge-info">EN CONVENIO</span>:</td>
                  <td><b id="catconv_count" style="font-size:17px;margin-left:10px;">0</b></td>
                  <td><span class="badge badge-info">FUERA DE CONVENIO</span>:</td>
                  <td><b id="catconvno_count" style="font-size:17px;margin-left:10px;">0</b></td>
                </tr>
              </table>
              <br>
              <div><b>PROMEDIO DE LOS ULTIMOS 15 DIAS:</b> <span id="promedio_nomina" style="font-weight:900;color:green;">0</span></div>
              <br>
              <div><b>PROMEDIO ANTIGUEDAD:</b> <span id="promedio_antiguedad" style="font-weight:900;color:green;">0</span></div>
            </div>
            <canvas id="legajosChart" width="400" height="50" style="margin-top:92px;"></canvas>
          </div>
        </div>
      </div>
    </div>
    <lista-carga v-if="triggers.load"></lista-carga>
    <div class="row" v-else>
      <div class="col-md-12 grid-margin stretch-card">
        <div class="card">
          <div class="card-body">
            <div class="table-responsive">
              <table id="empresas" class="table">
                <thead>
                  <tr>
                    <th>Perfil</th>
                    <th>Cod</th>
                    <th>Legajo</th>
                    <th>Nombre</th>
                    <th>Empleado por</th>
                    <th>Categoria</th>
                    <th>Operación</th>
                    <th>Zonal</th>
                    <th>Convenio</th>
                    <th>Accion</th>
                    <th>Calendario</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="personal in personal" :key="personal.legajo" :class="{'fila-no-distribuido': personal.cod=='-'}">
                    <td v-if="personal.avatar=='-'" style="color:#fff;">
                      2
                      <img width="40" height="40" style="border:1px solid #8b8b8b99;object-fit:cover" src="https://thumbs.dreamstime.com/b/perfil-de-usuario-vectorial-avatar-predeterminado-179376714.jpg">
                      <div class="bloqueado" v-if="personal.bloqueado">BLOQUEADO</div>
                    </td>
                    <td v-else style="color:#fff;">
                      1
                      <img width="40" height="40" style="object-fit:cover" :src="personal.avatar">
                      <div class="bloqueado" v-if="personal.bloqueado">BLOQUEADO</div>
                    </td>
                    <td>{{personal.bejerman}}</td>
                    <td>{{personal.legajo}}</td>
                    <td>{{personal.apellido}} <br> {{personal.nombre}}</td>
                    <td v-if="personal.razonsocial=='Food Service America'"><span class="badge badge-success">Food Service America</span></td>
                    <td v-else><span class="badge badge-info">Food Service Catering</span></td>
                    <td>{{personal.categoria}}</td>
                    <td>{{personal.operacion}}</td>
                    <td>{{personal.zonal}}</td>
                    <td>{{personal.convenio}}</td>
                    <td>
                      <button v-if="isEditor('Personal')" type="button" class="btn btn-info btn-xs ml-2" @click.prevent="abrirModalHorarios(personal.legajo, personal.nombre, personal.apellido)">
                        Horarios
                      </button>
                    </td>
                    <td>
                      <div class="mini-cal">
                        <span
                          v-for="d in diasSemana"
                          :key="d"
                          :class=" tieneHorario(personal.legajo, d) ? 'on' : 'off' "
                        >{{ d.charAt(0) }}</span>
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- modals existentes -->
    <modal-administrar
      v-if="modalAdministrar.open"
      :empresa="modalOperacionId"
      :legajoEmpleado="modalAdministrar.legajo"
      :nombreEmpleado="modalAdministrar.nombre"
      :apellidoEmpleado="modalAdministrar.apellido"
      :operacion="modalAdministrar.operacion"
      :idDistribucion="modalAdministrar.idDistribucion"
      @cerrar-modal-asignar="refrescarPersonal($event)"
    />
    <modal-bloquear
      v-if="modalBloquear.open"
      :dniEmpleado="modalBloquear.dni"
      :legajoEmpleado="modalBloquear.legajo"
      :nombreEmpleado="modalBloquear.nombre"
      :apellidoEmpleado="modalBloquear.apellido"
      @cerrar-modal-observar="refrescarPersonal($event)"
      v-on:keyup.enter="modalBloquear.open=false"
    />
    <modal-observar
      v-if="modalObservar.open"
      :dniEmpleado="modalObservar.dni"
      :legajoEmpleado="modalObservar.legajo"
      :nombreEmpleado="modalObservar.nombre"
      :apellidoEmpleado="modalObservar.apellido"
      @cerrar-modal-observar="refrescarPersonal($event)"
      v-on:keyup.enter="modalObservar.open=false"
    />
    <modal-vacunas
      v-if="modalVacunas.open"
      :dniEmpleado="modalVacunas.dni"
      :legajoEmpleado="modalVacunas.legajo"
      :nombreEmpleado="modalVacunas.nombre"
      :apellidoEmpleado="modalVacunas.apellido"
      :certificadoEmpleado="modalVacunas.certificado"
      @cerrar-modal-observar="refrescarPersonal($event)"
      v-on:keyup.enter="modalVacunas.open=false"
    />
    <modal-legales
      v-if="modalLegales.open"
      :dniEmpleado="modalLegales.dni"
      :nombreEmpleado="modalLegales.nombre"
      :apellidoEmpleado="modalLegales.apellido"
      :legajoEmpleado="modalLegales.legajo"
      @cerrar-modal-legales="refrescarPersonal($event)"
    />
    <!-- Modal Horarios -->
    <div v-if="modalHorarios.open" class="modal-backdrop">
      <div class="modal-dialog" @click.self="cerrarModalHorarios">
        <div class="modal-content p-4">
          <h5>Configurar Horarios – Legajo {{ modalHorarios.legajo }}</h5>
          <div class="mb-3">
            <label>Horario de entrada</label>
            <input type="time" v-model="bulkEntrada" class="form-control"/>
            <label class="mt-2">Horario de salida</label>
            <input type="time" v-model="bulkSalida" class="form-control"/>
            <button class="btn btn-sm btn-secondary mt-2" @click="aplicarBulk">
              Aplicar a todos los días
            </button>
          </div>
          <table class="table table-sm">
            <thead>
              <tr><th>Día</th><th>Trabaja</th><th>Entrada</th><th>Salida</th></tr>
            </thead>
            <tbody>
              <tr v-for="h in horariosForm" :key="h.dia">
                <td>{{h.dia}}</td>
                <td><input type="checkbox" v-model="h.trabaja"/></td>
                <td><input type="time" v-model="h.entrada" class="form-control form-control-sm" :disabled="!h.trabaja" @blur="formatTimeInput(h, 'entrada')"/></td>
                <td><input type="time" v-model="h.salida" class="form-control form-control-sm" :disabled="!h.trabaja" @blur="formatTimeInput(h, 'salida')"/></td>
              </tr>
            </tbody>
          </table>
          <div class="text-right">
            <button class="btn btn-light mr-2" @click="cerrarModalHorarios">Cancelar</button>
            <button class="btn btn-primary" :disabled="guardando" @click="guardarHorarios">
              {{ guardando ? 'Guardando…' : 'Guardar Horarios' }}
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios';
import $ from 'jquery';
require('datatables.net');
require('datatables.net-buttons/js/buttons.colVis.js')();
require('datatables.net-buttons/js/buttons.html5.js')();
require('datatables.net-buttons/js/buttons.flash.js')();
require('datatables.net-buttons/js/buttons.print.js')();
import ListaCarga from '../ListaCarga.vue';
import ModalAdministrar from './ModalAdministrar.vue';
import ModalObservar from './ModalObservar.vue';
import ModalBloquear from './ModalBloquear.vue';
import modalVacunas from './ModalVacunas.vue';
import ModalLegales from './ModalLegales';

const userPermission = JSON.parse(sessionStorage.getItem('userPermisos'));
// URL base de tu Firebase Realtime Database
const FIREBASE_BASE = 'https://aplicativos.firebaseio.com';

export default {
  name: 'Personal',
  components: { ListaCarga, ModalAdministrar, ModalLegales, ModalObservar, modalVacunas, ModalBloquear },
  data() {
    return {
      breadcrumbA: 'Inicio',
      breadcrumbB: 'Personal',
      descripcion: 'En este modulo usted podra visualizar y administrar todo el personal de la empresa',
      triggers: { load: true },
      personal: [],
      novedades: [],
      modalObservar: { open: false, dni: null, nombre: '', apellido: '', legajo: null },
      modalBloquear: { open: false, dni: null, nombre: '', apellido: '', legajo: null },
      modalVacunas: { open: false, dni: null, nombre: '', apellido: '', legajo: null, certificado: null },
      modalAdministrar: { open: false, legajo: null, nombre: '', apellido: '', operacion: null, idDistribucion: null },
      modalLegales: { open: false, dni: null, nombre: '', apellido: null, legajo: null },
      // datos para modal Horarios
      modalHorarios: { open: false, legajo: null, nombre: '', apellido: '' },
      horariosForm: [],
      bulkEntrada: '',
      bulkSalida: '',
      guardando: false,
      diasSemana: ['Lunes','Martes','Miércoles','Jueves','Viernes','Sábado','Domingo'],
      horariosAll: {},    // para cachear los horarios que traés de Firebase
    };
  },
  methods: {
    isEditor(modulo) {
      const record = userPermission.find(r => r.ModulosAccess === modulo);
      return record ? record.Editor : false;
    },
    observarPersonalId(dni, nombre, apellido, legajo) {
      this.modalObservar = { open: true, dni, nombre, apellido, legajo };
      setTimeout(() => this.modalObservar.open = true, 200);
    },
    bloquear(dni, nombre, apellido, legajo) {
      this.modalBloquear = { open: true, dni, nombre, apellido, legajo };
      setTimeout(() => this.modalBloquear.open = true, 200);
    },
    vacunas(dni, nombre, apellido, legajo, certificado) {
      this.modalVacunas = { open: true, dni, nombre, apellido, legajo, certificado: certificado || null };
      setTimeout(() => this.modalVacunas.open = true, 200);
    },
    abrirModalAdministrar(legajo, nombre, apellido, operacion, idDistribucion) {
      this.modalAdministrar = {
        open: true,
        legajo,
        nombre,
        apellido,
        operacion: operacion === '-' ? undefined : operacion,
        idDistribucion
      };
    },
    abrirModalLegales(dni, nombre, apellido, legajo) {
      this.modalLegales = { open: true, dni, nombre, apellido, legajo };
    },
    abrirModalHorarios(legajo, nombre, apellido) {
      this.modalHorarios = { open: true, legajo, nombre, apellido };
      // si hay algo guardado, lo uso, si no, el default
      const saved = this.horariosAll[legajo];
      if (saved && Array.isArray(saved.horarios)) {
        this.horariosForm = saved.horarios.map(h => ({
          dia:    h.dia,
          trabaja: h.trabaja,
          entrada: h.entrada || '', // Asegura que sea una cadena, no null/undefined
          salida:  h.salida || ''    // Asegura que sea una cadena, no null/undefined
        }));
      } else {
        const dias = ['Lunes','Martes','Miércoles','Jueves','Viernes','Sábado','Domingo'];
        this.horariosForm = dias.map(d => ({
          dia:     d,
          trabaja: d==='Sábado'||d==='Domingo'? false : true,
          entrada: '',
          salida:  ''
        }));
      }
      this.bulkEntrada = '';
      this.bulkSalida  = '';
    },
    aplicarBulk() {
      this.horariosForm.forEach(h => {
        if (h.trabaja) {
          h.entrada = this.bulkEntrada;
          h.salida  = this.bulkSalida;
        }
      });
    },
    cerrarModalHorarios() {
      this.modalHorarios.open = false;
    },
    // Nueva función para formatear y validar la entrada de tiempo
    formatTimeInput(item, field) {
      const value = item[field];
      // Expresión regular para validar el formato HH:mm
      const validTimeRegex = /^(?:2[0-3]|[01]?[0-9]):(?:[0-5]?[0-9])$/;

      if (value && !validTimeRegex.test(value)) {
        item[field] = ''; // Limpia la entrada inválida
        this.$toast && this.$toast.error(`Formato de hora inválido para ${field}. Por favor, usa HH:mm (ej. 09:00, 14:30).`);
      }
      // Si el valor está vacío o ya es válido, no se hace nada.
    },
    async guardarHorarios() {
      this.guardando = true;
      try {
        // Prepara los datos para asegurar que entrada y salida siempre sean cadenas
        const horariosToSave = this.horariosForm.map(h => ({
          dia: h.dia,
          trabaja: h.trabaja,
          entrada: h.entrada || '', // Asegura que sea una cadena, no null/undefined
          salida: h.salida || ''    // Asegura que sea una cadena, no null/undefined
        }));

        // Guarda en Firebase under /horarios/{legajo}.json
        await axios.put(
          `${FIREBASE_BASE}/horarios/${this.modalHorarios.legajo}.json`,
          {
            legajo: this.modalHorarios.legajo,
            nombre: this.modalHorarios.nombre + ' ' + this.modalHorarios.apellido,
            horarios: horariosToSave, // Usa los datos preparados
            cargado: true
          }
        );
        this.$toast && this.$toast.success('Horarios guardados en Firebase correctamente');
        this.cerrarModalHorarios();
        // refrescar tabla de personal (si corresponde)
        $('#empresas').dataTable().fnDestroy();
        this.obtenerPersonal();
      } catch (e) {
        console.error(e);
        this.$toast && this.$toast.error('Error al guardar horarios en Firebase');
      } finally {
        this.guardando = false;
      }
    },
    tieneHorario(legajo, dia) {
      const rec = this.horariosAll[legajo];
      if (!rec || !rec.horarios) return false;
      const h = rec.horarios.find(x => x.dia === dia);
      // Un día está "on" (verde) si trabaja Y tiene horarios de entrada y salida no vacíos
      return !!h && h.trabaja && h.entrada !== '' && h.salida !== '';
    },
    async obtenerPersonal(){
      this.triggers.load = true;
      const axiosrequest1 = axios.get('https://consumos.foodservice.com.ar/api/empresas');
      const axiosrequest2 = axios.get('https://auth.foodservice.com.ar/?type=personal_mysql&empresa=1&access_token=1234567');
      const axiosrequest3 = axios.get('https://aplicativos.firebaseio.com/distribucion.json?print=pretty');
      const axiosrequest4 = axios.get('https://aplicativos.firebaseio.com/zonal.json?print=pretty');
      const axiosrequest5 = axios.get('https://aplicativos.firebaseio.com/categorias.json?print=pretty');
      const axiosrequest6 = axios.get('https://aplicativos.firebaseio.com/legales.json?print=pretty');
      const axiosrequest7 = axios.get('https://aplicativos.firebaseio.com/sectores.json?print=pretty');
      const axiosrequest8 = axios.get('https://auth.foodservice.com.ar/?type=personal_mysql&empresa=2&access_token=1234567');
      const axiosrequest9 = axios.get('https://aplicativos.firebaseio.com/observacion_personal.json?print=pretty');
      const axiosrequest10 = axios.get('https://aplicativos.firebaseio.com/manipulacion.json?print=pretty');
      const axiosrequest11 = axios.get('https://aplicativos.firebaseio.com/certificado_vacunacion.json?print=pretty');
      const axiosrequest12 = axios.get('https://aplicativos.firebaseio.com/vacunas_personal.json?print=pretty');
      const axiosrequest13 = axios.get('https://aplicativos.firebaseio.com/perfil.json?print=pretty');
      const regional_dato = axios.get('https://aplicativos.firebaseio.com/regional.json?print=pretty');
      const axiosrequest14 = axios.get('https://aplicativos.firebaseio.com/categorias_cat.json?print=pretty');
      const axiosrequest15 = axios.get('https://auth.foodservice.com.ar/?type=promedio_nomina&dias=15&access_token=1234567');
      const axiosrequest16 = axios.get('https://aplicativos.firebaseio.com/bloqueos.json?print=pretty');
      const axiosrequest17 = axios.get('https://aplicativos.firebaseio.com/datos_validados.json?print=pretty');
      const axiosrequestHorarios = axios.get(`${FIREBASE_BASE}/horarios.json`);

      await axios.all([axiosrequest1, axiosrequest2, axiosrequest3, axiosrequest4, axiosrequest5, axiosrequest6, axiosrequest7,axiosrequest8,axiosrequest9,axiosrequest10,axiosrequest11,axiosrequest12,axiosrequest13,regional_dato,axiosrequest14,axiosrequest15,axiosrequest16,axiosrequest17,axiosrequestHorarios]).then(
        axios.spread((operaciones, personal, distribucion, zonal, categorias, legales, sectores,personal_cat,observaciones,manipulacion,vacunacion,dosis,avatar,regional_data,categorias_cat,promedio_nomina,bloqueos,validados,horariosResp) => {
          this.horariosAll = horariosResp.data || {};
          console.log(promedio_nomina.data)
          const data = promedio_nomina.data;
          // Preparar los datos para el gráfico
          const fechas = data.map(entry => entry.fecha);
          const legajos = data.map(entry => entry.legajos);
          // Calcular el promedio de legajos
          const promedio = legajos.reduce((a, b) => a + b, 0) / legajos.length;
          // Crear el gráfico de líneas
          const ctx = document.getElementById('legajosChart').getContext('2d');
          const legajosChart = new Chart(ctx, {
            type: 'line',
            data: {
              labels: fechas,
              datasets: [{
                label: 'Total personal activo',
                data: legajos,
                borderColor: 'rgba(75, 192, 192, 1)',
                borderWidth: 1,
                fill: false
              }]
            },
            options: {
              scales: {
                x: {
                  type: 'time',
                  time: {
                    unit: 'day',
                    tooltipFormat: 'MMM DD'
                  }
                },
                y: {
                  beginAtZero: false
                }
              }
            }
          });
          document.getElementById('promedio_nomina').innerText = promedio.toFixed(0);
          var lista = [];
          var observacion = false;
          var bloqueado = false;

          const result_categoria = (id) => {
            var categoria = "";
            $.each(categorias.data, function(clave, value) {
              if (value.codigo == id) {
                categoria = value.nombre;
              }
            })
            return categoria;
          }
          const result_validado = (id) => {
            var valido = "NO";
            $.each(validados.data, function(clave, value) {
              if (clave == id) {
                valido = "SI";
              }
            })
            return valido;
          }
          const result_categoria_cat = (id) => {
            var categoria = "";
            $.each(categorias_cat.data, function(clave, value) {
              if (value.codigo == id) {
                categoria = value.nombre;
              }
            })
            return categoria;
          }
          const result_distribucion = (id) => {
            var distri = "";
            $.each(distribucion.data, function(clave, value) {
              $.each(value, function(k, v) {
                if (v.legajo == id) {
                  distri = {
                    operacion: clave,
                    idDistribucion: k
                  }
                }
              })
            });
            return distri;
          }
          const result_operacion = (id) => {
            var operacion = "";
            // Busca primero al empleado en sectores que es mas pequeño
            Object.keys(sectores.data).forEach((sector)=>{
              // console.log(sectores.data[sector].id_empresa +"=="+id);
              if (sectores.data[sector].id_empresa == id) {
                operacion = sectores.data[sector].operacion;
              }
            })
            // Si no encontro un sector asociado busca una empresa asociada
            if (operacion == "") {
              $.each(operaciones.data, function(clave, value) {
                if (value.id == id) {
                  operacion = value.name;
                }
              })
            }
            return operacion;
          }
          const result_madre = (id) => {
            var operacion = "";
            // Busca primero al empleado en sectores que es mas pequeño
            Object.keys(sectores.data).forEach((sector)=>{
              // console.log(sectores.data[sector].id_empresa +"=="+id);
              if (sectores.data[sector].id_empresa == id) {
                operacion = "-";
              }
            })
            // Si no encontro un sector asociado busca una empresa asociada
            if (operacion == "") {
              $.each(operaciones.data, function(clave, value) {
                if (value.id == id) {
                  operacion = value.empresa_madre;
                }
              })
            }
            return operacion;
          }
          const result_tipo = (id) => {
            var operacion = "";
            // Busca primero al empleado en sectores que es mas pequeño
            Object.keys(sectores.data).forEach((sector)=>{
              // console.log(sectores.data[sector].id_empresa +"=="+id);
              if (sectores.data[sector].id_empresa == id) {
                operacion = "Planta Central";
              }
            })
            // Si no encontro un sector asociado busca una empresa asociada
            if (operacion == "") {
              $.each(operaciones.data, function(clave, value) {
                if (value.id == id) {
                  operacion = value.tipo_empresa;
                }
              })
            }
            return operacion;
          }
          const result_operacion_bejerman = (id) => {
            var operacion = "";
            // Busca primero al empleado en sectores que es mas pequeño
            Object.keys(sectores.data).forEach((sector)=>{
              // console.log(sectores.data[sector].id_empresa +"=="+id);
              if (sectores.data[sector].id_empresa == id) {
                operacion = 'S'+sectores.data[sector].id;
              }
            })
            // Si no encontro un sector asociado busca una empresa asociada
            if (operacion == "") {
              $.each(operaciones.data, function(clave, value) {
                if (value.id == id) {
                  operacion = value.catering_id;
                }
              })
            }
            return operacion;
          }
          const result_apropiacion = (id) => {
            var operacion = "";
            var apropiacion = "";
            // Busca primero al empleado en sectores que es mas pequeño
            Object.keys(sectores.data).forEach((sector)=>{
              // console.log(sectores.data[sector].id_empresa +"=="+id);
              if (sectores.data[sector].id_empresa == id) {
                apropiacion = sectores.data[sector].id_empresa;
              }
            })
            // Si no encontro un sector asociado busca una empresa asociada
            if (operacion == "") {
              $.each(operaciones.data, function(clave, value) {
                if (value.id == id) {
                  // apropiacion = value.centroapropiacion_id
                  apropiacion = value.id
                }
              })
            }
            return apropiacion;
          }
          const result_zonal = (id) => {
            var zonales = "";
            $.each(zonal.data, function(clave, value) {
              if (clave == id) {
                zonales = value.nombre;
              }
            })
            return zonales;
          }
          const result_manipulador = (dni) => {
            var manip = "";
            $.each(manipulacion.data, function(clave, value) {
              if (clave == dni) {
                manip = value.link;
              }
            })
            return manip;
          }
          const result_manipulador_vto = (dni) => {
            var manip = "";
            $.each(manipulacion.data, function(clave, value) {
              if (clave == dni) {
                manip = value.vto;
              }
            })
            return manip;
          }
          const result_vacunacion = (legajo) => {
            var vacu = "";
            $.each(vacunacion.data, function(clave, value) {
              if (clave == legajo) {
                vacu = value.certificado;
              }
            })
            return vacu;
          }
          const result_dosis = (dni) => {
            var dos = "";
            $.each(dosis.data, function(clave, value) {
              if (clave == dni) {
                // console.log("datos obtenidos!")
                dos = Object.keys(value).length/2
              }
            })
            return dos;
          }
          const result_avatar = (dni) => {
            var avtr = "";
            $.each(avatar.data, function(clave, value) {
              if (clave == dni) {
                avtr = value.imagen;
              }
            })
            return avtr;
          }
          const reemplazarIndefinido = (string) => {
            if (string==undefined || string == null || string == '') {
              return "-"
            }
            return string
          }
          const reemplazarIndefinidoDosis = (string) => {
            if (string==undefined || string == null || string == '') {
              return "0"
            }
            return string
          }
          var america_count=[];
          var catering_count=[];
          var regional="";
          var ameconv_count = 0;
          var amenoconv_count = 0;
          var catconv_count = 0;
          var catnoconv_count = 0;
          var masculinos_count = 0;
          var femeninos_count = 0;
          const calcularAntiguedad = (fechaInicio) => {
            const fecha = new Date(fechaInicio);
            const hoy = new Date();
            let años = hoy.getFullYear() - fecha.getFullYear();
            let meses = hoy.getMonth() - fecha.getMonth();
            let dias = hoy.getDate() - fecha.getDate();
            // Ajuste de días si es necesario
            if (dias < 0) {
              meses--;
              const mesAnterior = new Date(hoy.getFullYear(), hoy.getMonth(), 0);
              dias += mesAnterior.getDate();
            }
            // Ajuste de meses si es necesario
            if (meses < 0) {
              años--;
              meses += 12;
            }
            // Calcular el total de años en formato decimal
            const totalDiasEnElAño = (hoy.getFullYear() % 4 === 0 && (hoy.getFullYear() % 100 !== 0 || hoy.getFullYear() % 400 === 0)) ? 366 : 365;
            const antiguedadDecimal = años + (meses / 12) + (dias / totalDiasEnElAño);
            return antiguedadDecimal.toFixed(2); // Redondeado a dos decimales
          };
          // Ejemploconsole.log("promedio de prueba")console.log(calcularAntiguedad("2002-09-01"));
          const calcularPromedioAntiguedad = (datos) => {
            // Paso 1: Calcular la cantidad total de meses
            const totalMeses = datos.reduce((acumulador, antiguedad) => {
              const [años, decimales] = antiguedad.toString().split(".").map(Number);
              const meses = decimales ? (decimales / 100) * 12 : 0; // Convertir decimales en meses
              return acumulador + (años * 12) + meses;
            }, 0);
            // Paso 2: Calcular el promedio de meses
            const promedioMeses = totalMeses / datos.length;
            // Paso 3: Convertir el promedio de meses a un valor decimal en años y redondear el segundo decimal hacia arriba
            const promedioAniosDecimal = Math.ceil((promedioMeses / 12) * 10) / 10;
            return promedioAniosDecimal; // Devolver como número decimal
          };
          const calcularPromedioAntiguedadAjustada=(datos) => {
            // Ajustar las antigüedades según la lógica
            const antiguedadesAjustadas = datos.map((antiguedad) => {
              const [años, mesesDecimales] = antiguedad.toString().split(".").map(Number);
              const meses = Math.round((mesesDecimales || 0) * 10 / 10); // Convertir los decimales en meses
              return meses >= 3 ? años + 1 : años; // Sumar un año si tiene 3 o más meses
            });
            // Calcular el promedio de los años ajustados
            const totalAños = antiguedadesAjustadas.reduce((acumulador, años) => acumulador + años, 0);
            const promedioAños = totalAños / antiguedadesAjustadas.length;
            // Convertir el promedio a años completos y meses
            const añosCompletos = Math.floor(promedioAños);
            const mesesRestantes = Math.round((promedioAños - añosCompletos) * 12);
            // Ajustar si los meses llegan a 12
            const añosFinales = añosCompletos + Math.floor(mesesRestantes / 12);
            const mesesFinales = mesesRestantes % 12;
            return { años: añosFinales, meses: mesesFinales };
          }
          var antiguedades = [];
          var antiguedades_america = [];
          var antiguedades_catering = [];
          $.each(personal.data, function(clave, valor) {
            observacion = (observaciones.data[valor.leg_numdoc] != undefined) ? true : false;
            bloqueado = (bloqueos.data[valor.leg_numdoc] != undefined) ? true : false;
            if(legales.data[valor.leg_numdoc] != null) return true;
            if (valor.leg_fecegr == null) {
              let distribucion = result_distribucion(valor.leg_numero);
              if (regional_data.data!=null) {
                var key_regional = Object.keys(regional_data.data).filter(key => key == distribucion.operacion);
                var result_regional = key_regional.reduce((r, k) => r.concat(regional_data.data[k]), []);
                if (result_regional[0]==null) {
                  regional = "-";
                }else{
                  regional = result_regional[0].nombre;
                }
              }else{
                regional = '-';
              }
              // Verifica si 'sec_descrip' no contiene la palabra 'cct'
              var palabra = valor.sec_descrip.toLowerCase().includes('cct') ? 'DENTRO DE CONVENIO' : 'FUERA DE CONVENIO';
              if (palabra=="FUERA DE CONVENIO") {
                amenoconv_count++;
              }else{
                ameconv_count++;
              }
              if (valor.leg_sexo==1) {
                var genero = "Masculino";
                masculinos_count++
              }else{
                var genero = "Femenino";
                femeninos_count++;
              }
              $("#ameconv_count").html(ameconv_count)
              $("#ameconvno_count").html(amenoconv_count)
              antiguedades_america.push( calcularAntiguedad(valor.leg_fecingr.replace(" 00:00:00", "")) );
              antiguedades.push(calcularAntiguedad(valor.leg_fecingr.replace(" 00:00:00", "")));
              lista.push({
                "cod": reemplazarIndefinido(result_apropiacion(distribucion.operacion)),
                "razonsocial": "Food Service America",
                "bejerman": reemplazarIndefinido(result_operacion_bejerman(distribucion.operacion)),
                "legajo": reemplazarIndefinido(valor.leg_numero),
                "nombre": reemplazarIndefinido(valor.leg_nombre),
                "apellido": reemplazarIndefinido(valor.leg_apellido),
                "ingreso": reemplazarIndefinido(valor.leg_fecingr.replace(" 00:00:00", "")),
                "antiguedad":calcularAntiguedad(valor.leg_fecingr.replace(" 00:00:00", "")),
                "categoria": reemplazarIndefinido(valor.cat_descrip),
                "nacimiento": reemplazarIndefinido(valor.leg_fecnac.replace(" 00:00:00", "")),
                "cuil": reemplazarIndefinido(valor.leg_cuil),
                "genero": genero,
                "operacion": reemplazarIndefinido(result_operacion(distribucion.operacion)),
                "madre": reemplazarIndefinido(result_madre(distribucion.operacion)),
                "tipo": reemplazarIndefinido(result_tipo(distribucion.operacion)),
                "idDistribucion": distribucion.idDistribucion,
                "zonal": reemplazarIndefinido(result_zonal(result_distribucion(valor.leg_numero).operacion)),
                "dni": valor.leg_numdoc,
                "observacion":observacion,
                "bloqueado":bloqueado,
                "manipulador":reemplazarIndefinido(result_manipulador(valor.leg_numdoc)),
                "manipulador_vto":reemplazarIndefinido(result_manipulador_vto(valor.leg_numdoc)),
                "vacunado":reemplazarIndefinido(result_vacunacion(valor.leg_numero)),
                "dosis":reemplazarIndefinidoDosis(result_dosis(valor.leg_numdoc)),
                "avatar": reemplazarIndefinido(result_avatar(valor.leg_numdoc)),
                "regional":regional,
                "convenio":reemplazarIndefinido(valor.sec_descrip),
                "validado":result_validado(valor.leg_numdoc)
              })
              america_count.push(1);
            }
          });
          $.each(personal_cat.data, function(clave, valor) {
            observacion = (observaciones.data[valor.leg_numdoc] != undefined) ? true : false;
            bloqueado = (bloqueos.data[valor.leg_numdoc] != undefined) ? true : false;
            if(legales.data[valor.leg_numdoc] != null) return true;
            if (valor.leg_fecegr == null) {
              let distribucion = result_distribucion(valor.leg_numero);
              if (regional_data.data!=null) {
                var key_regional = Object.keys(regional_data.data).filter(key => key == distribucion.operacion);
                var result_regional = key_regional.reduce((r, k) => r.concat(regional_data.data[k]), []);
                if (result_regional[0]==null) {
                  regional = "-";
                }else{
                  regional = result_regional[0].nombre;
                }
              }else{
                regional = '-';
              }
              if (valor.sec_descrip=="FUERA DE CONVENIO") {
                catnoconv_count++;
              }else{
                catconv_count++;
              }
              $("#catconv_count").html(catconv_count)
              $("#catnoconv_count").html(catnoconv_count)
              if (valor.leg_sexo==1) {
                var genero = "Masculino";
                masculinos_count++;
              }else{
                var genero = "Femenino";
                femeninos_count++;
              }
              antiguedades_catering.push(calcularAntiguedad(valor.leg_fecingr.replace(" 00:00:00", "")));
              antiguedades.push(calcularAntiguedad(valor.leg_fecingr.replace(" 00:00:00", "")));
              lista.push({
                "cod": reemplazarIndefinido(result_apropiacion(distribucion.operacion)),
                "razonsocial": "Food Service Catering",
                "bejerman": reemplazarIndefinido(result_operacion_bejerman(distribucion.operacion)),
                "legajo": reemplazarIndefinido(valor.leg_numero),
                "nombre": reemplazarIndefinido(valor.leg_nombre),
                "apellido": reemplazarIndefinido(valor.leg_apellido),
                "ingreso": reemplazarIndefinido(valor.leg_fecingr.replace(" 00:00:00", "")),
                "antiguedad":calcularAntiguedad(valor.leg_fecingr.replace(" 00:00:00", "")),
                "categoria": reemplazarIndefinido(valor.cat_descrip),
                "nacimiento": reemplazarIndefinido(valor.leg_fecnac.replace(" 00:00:00", "")),
                "cuil": reemplazarIndefinido(valor.leg_cuil),
                "genero": genero,
                "operacion": reemplazarIndefinido(result_operacion(distribucion.operacion)),
                "madre": reemplazarIndefinido(result_madre(distribucion.operacion)),
                "tipo": reemplazarIndefinido(result_tipo(distribucion.operacion)),
                "idDistribucion": distribucion.idDistribucion,
                "zonal": reemplazarIndefinido(result_zonal(result_distribucion(valor.leg_numero).operacion)),
                "dni": valor.leg_numdoc,
                "observacion":observacion,
                "bloqueado":bloqueado,
                "manipulador":reemplazarIndefinido(result_manipulador(valor.leg_numdoc)),
                "manipulador_vto":reemplazarIndefinido(result_manipulador_vto(valor.leg_numdoc)),
                "vacunado":reemplazarIndefinido(result_vacunacion(valor.leg_numero)),
                "dosis":reemplazarIndefinidoDosis(result_dosis(valor.leg_numdoc)),
                "avatar": reemplazarIndefinido(result_avatar(valor.leg_numdoc)),
                "regional":regional,
                "convenio":reemplazarIndefinido(valor.sec_descrip),
                "validado":result_validado(valor.leg_numdoc)
              })
              catering_count.push(1);
            }
          });
          $("#america_count").html(america_count.length)
          $("#catering_count").html(catering_count.length)
          $("#femeninos").html(femeninos_count)
          $("#masculinos").html(masculinos_count)
          console.log("ANTIGUEDAD AMERICA")
          console.log(calcularPromedioAntiguedad(antiguedades_america))
          console.log("ANTIGUEDAD CATERING")
          console.log(calcularPromedioAntiguedad(antiguedades_catering))
          console.log("ANTIGUEDAD GENERAL")
          console.log(antiguedades)
          console.log(calcularPromedioAntiguedad(antiguedades))
          $("#promedio_antiguedad").html(calcularPromedioAntiguedad(antiguedades))
          console.log("ANTIGUEDAD AJUSTADA")
          console.log(calcularPromedioAntiguedadAjustada(antiguedades))
          console.log(lista);
          this.personal = lista;
          this.triggers.load = false;
        })).then(() => {
          var tabla =  $('#empresas').DataTable({
            "language": {
              "decimal": ",",
              "thousands": ".",
              "info": "Mostrando registros del _START_ al _END_ de un total de _TOTAL_ registros",
              "infoEmpty": "Mostrando registros del 0 al 0 de un total de 0 registros",
              "infoPostFix": "",
              "infoFiltered": "(filtrado de un total de _MAX_ registros)",
              "loadingRecords": "Cargando...",
              "lengthMenu": "Mostrar _MENU_ registros",
              "paginate": {
                "first": "Primero",
                "last": "Último",
                "next": "Siguiente",
                "previous": "Anterior"
              },
              "processing": "Procesando...",
              "search": "Buscar:",
              "searchPlaceholder": "Término de búsqueda",
              "zeroRecords": "No se encontraron resultados",
              "emptyTable": "Ningún dato disponible en esta tabla",
              "aria": {
                "sortAscending":  ": Activar para ordenar la columna de manera ascendente",
                "sortDescending": ": Activar para ordenar la columna de manera descendente"
              },
            },
            "scrollX": false,
            "search": {regex:true},
            dom: 'Bfrtip',
            "order": [
              [6, "desc"]
            ],
            responsive: false,
            nowrap: false,
            buttons: [
              'copy',
              'excel',
              'csv',
              'pdf'
            ]
          });
        });
    },
    refrescarPersonal(seReasigno) {
      this.modalAdministrar.open = false;
      this.modalLegales.open = false;
      this.modalObservar.open = false;
      this.modalBloquear.open = false;
      this.modalVacunas.open = false;
      if (seReasigno) {
        $('#empresas').dataTable().fnDestroy();
        this.obtenerPersonal();
      }
    }
  },
  mounted() {
    this.obtenerPersonal();
  }
};
</script>

<style scoped>
.fila-no-distribuido { background: radial-gradient(#ff00001a, transparent 91%); }
.observacion-existente { background:#10b759;border-radius:50%;padding:3px 4px;position:absolute;transform:translate(60px,-20px); }
.bloqueado { background:red;color:white;padding:10px;position:absolute;transform:translate(60px,-20px); }
#info_legajo { position:fixed;width:100vw;height:100vh;background-color:#fff;z-index:9999999;padding:40px;left:0;top:0;display:none;overflow-y:scroll; }
#info_legajo td { border:1px solid #ccc; }
#legajo_foto { width:300px;height:300px;background-color:#ccc; }
.circulo { width:100px;height:100px;background:#b7b5b5;border-radius:50%; }
#novedades_legajo td { font-size:10px; }
#header_legajo { width:100%;background-color:#7e86ed;height:37px;position:fixed;left:0;top:0; }
.modal-backdrop {  position: fixed; top: 0; left: 0; width: 100vw; height: 100vh;  background: rgba(0,0,0,0.5); display: flex; align-items: center; justify-content: center; z-index: 10000;}
.modal-dialog {  background: #fff; border-radius: 0.25rem; max-width: 600px; width: 100%;}
.mini-cal { display: flex; gap: 2px; }
.mini-cal span {
  width: 16px; height: 16px;
  display: flex; align-items: center; justify-content: center;
  font-size: 10px; color: #fff; border-radius: 2px;
}
.on  { background: #28a745; }
.off { background: #dc3545; }
</style>